import { z } from 'zod';
import { PAGINATION_PAGE_SIZE_DEFAULT } from '~/constants';

import {
  zodDeliveryNotesFilterAggregatorSchema,
  zodDeliveryNotesFilterGroupSchema,
} from '../useQueryDeliveryNotesAdmin';

import { DELIVERY_NOTE_FILTER_ENTITY_NAMES } from './constants';

export const zodDeliveryNoteFilterSuggestionsParamsSchema = z
  .object({
    entity: z.enum(DELIVERY_NOTE_FILTER_ENTITY_NAMES),
    filterConfig: z
      .strictObject({
        filterAggr: zodDeliveryNotesFilterAggregatorSchema,
        filterGroups: z.array(zodDeliveryNotesFilterGroupSchema),
      })
      .prefault({
        filterAggr: 'and',
        filterGroups: [],
      }),
    limit: z
      .int()
      .positive()
      .lte(200)
      .optional()
      .prefault(PAGINATION_PAGE_SIZE_DEFAULT),
    offset: z.int().nonnegative().optional().prefault(0),
    searchValue: z.string().optional(),
  })
  .transform((value) => {
    // Remove the current filter entity from all filter clauses so values aren't filtered out that should be suggested.
    const cleanedFilterConfig = {
      filterConfig: {
        ...value.filterConfig,
        filterGroups: value.filterConfig.filterGroups
          .map((group) => ({
            ...group,
            // Remove filter clauses for the current filter entity.
            filterClauses: group.filterClauses.filter(
              ({ name }) => name !== value.entity,
            ),
          }))
          // Remove filter groups with no filter clauses.
          .filter((group) => group.filterClauses.length > 0),
      },
    };

    return {
      ...value,
      ...cleanedFilterConfig,
    };
  });
